import { GroupUserRole } from 'multirpc-sdk';

export enum AccountPermission {
  ChainItem, // access to the chain item page
  UsageData, // access to the Telemetry,
  Billing, // access to the Billing information (account details page)
  Payment, // access to the payment form
  JwtManagerWrite, // permissions to create or delete project
  JwtManagerRead, // permissions see the list of JWTs
  AccountStatus, // access to account status information
  TosStatus, // access to the TOS status information
  UpgradePlan, // permissions to upgrade current plan
  ProjectsWelcomeDialog, // permissions to see welcome dialog (projects page)
  StatusTransition, // permissions to have status transition state
  EnterpriseStatus, // permissions to request group enterprise status

  // Teams permissions
  TeamManagement, // permissions to manage team
  TeamRenaming, // permission to rename existing team
  TeamOwnershipTransfer, // permissions to transfer team ownership
  Teammates, // permission to see and invite teammates
  TeamNotifications, // permission to manage team's notifications
  TeamLeaving, // permissions to leave team

  // Menu buttons
  AdvancedApiMenuItem,
  ProjectsMenuItem,
  AnalyticsMenuItem,
  CommonMenuItem,
}

const ADMIN_PERMISSIONS = [
  AccountPermission.ChainItem,
  AccountPermission.UsageData,
  AccountPermission.Billing,
  AccountPermission.Payment,
  AccountPermission.JwtManagerWrite,
  AccountPermission.JwtManagerRead,
  AccountPermission.AccountStatus,
  AccountPermission.TosStatus,
  AccountPermission.UpgradePlan,
  AccountPermission.ProjectsWelcomeDialog,
  AccountPermission.StatusTransition,
  AccountPermission.EnterpriseStatus,
  AccountPermission.AdvancedApiMenuItem,
  AccountPermission.ProjectsMenuItem,
  AccountPermission.AnalyticsMenuItem,
  AccountPermission.CommonMenuItem,
  AccountPermission.Teammates,
  AccountPermission.TeamManagement,
  AccountPermission.TeamNotifications,
];

const OWNER_PERMISSIONS = [
  ...ADMIN_PERMISSIONS,
  AccountPermission.TeamOwnershipTransfer,
  AccountPermission.TeamRenaming,
];

const DEVELOPER_PERMISSIONS = [
  AccountPermission.ChainItem,
  AccountPermission.UsageData,
  AccountPermission.JwtManagerRead,
  AccountPermission.AccountStatus,
  AccountPermission.AdvancedApiMenuItem,
  AccountPermission.ProjectsMenuItem,
  AccountPermission.AnalyticsMenuItem,
  AccountPermission.CommonMenuItem,
  AccountPermission.TeamLeaving,
];

const FINANCE_PERMISSIONS = [
  AccountPermission.Billing,
  AccountPermission.Payment,
  AccountPermission.TosStatus,
  AccountPermission.CommonMenuItem,
  AccountPermission.TeamLeaving,
];

export const permissionsMap: Record<GroupUserRole, AccountPermission[]> = {
  [GroupUserRole.admin]: ADMIN_PERMISSIONS,
  [GroupUserRole.dev]: DEVELOPER_PERMISSIONS,
  [GroupUserRole.finance]: FINANCE_PERMISSIONS,
  [GroupUserRole.owner]: OWNER_PERMISSIONS,
};
